import * as svg from "../../../assets/solid-chevron-up.svg";

import {iconBuilder} from "./iconBuilder";

export const SolidChevronUpIcon = iconBuilder(svg, "SolidChevronUpIcon", "0 0 10 7");
